import { accountRole } from 'src/const/state/account';

export const isSelfAccount = () => {
  // 自助开户102
  const { customer_type_value = null } = window.PERMISSION_DATA?.account ?? {};
  return +customer_type_value === accountRole.ROLE_SLEF_ACCOUNT;
};
export const transactionOptions = [
  {
    labelKey: 'transaction_type_all',
    value: 0,
    hide: true,
    colKey: 'transaction_type_all',
  },
  {
    labelKey: 'transaction_type_costs',
    value: isSelfAccount() ? 5 : 2,
    colKey: 'transaction_type_cost',
  },
  {
    labelKey: 'transaction_type_payments',
    value: isSelfAccount() ? 4 : 1,
    colKey: 'transaction_type_payment',
  },
  {
    labelKey: 'transaction_type_taxes',
    value: 3,
    colKey: 'transaction_type_tax',
  },
];

export const getColKeyByVal = val => transactionOptions.find(item => item.value === val).colKey;
